require('./shared')

// require('../site_scripts/mtc_vue_import')

require('./shared_functions')
require('../site_scripts/mtc_lazy_load_recaptcha_form')
// require('../site_scripts/mtc_submit_form')
// require('../site_scripts/mtc_small_enquiry_form')
require('../site_scripts/mtc_simple_form_submit')

// page specific styles
require('../../styles/entry/funky-cat-landing.less')